module.exports = __webpack_public_path__ + "img/biandonging.a20f0a7e.png";